"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.messagesByUser = exports.orderRatingByTokenQuery = exports.userOrderDetailsByTokenQuery = exports.orderDetailsByTokenQuery = exports.ordersMessagesByUser = exports.ordersByUser = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const order_1 = require("../fragments/order");
const invoice_1 = require("../fragments/invoice");
const checkout_1 = require("../fragments/checkout");
exports.ordersByUser = (0, graphql_tag_1.default) `
  ${checkout_1.checkoutAddressFragment}
  query OrdersByUser($perPage: Int!, $after: String) {
    me {
      id
      firstName
      lastName
      isStaff
      defaultShippingAddress {
        ...Address
      }
      defaultBillingAddress {
        ...Address
      }
      addresses {
        ...Address
      }
      orders(first: $perPage, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            token
            number
            statusDisplay
            created
            reservations {
              rentalStartDate
              rentalEndDate
            }
            user {
              firstName
            }
            total {
              gross {
                amount
                currency
              }
              net {
                amount
                currency
              }
            }
            lines {
              id
              returnAddress {
                id
              }
              variant {
                id
                product {
                  name
                  id
                  slug
                }
              }
              thumbnail {
                alt
                url
              }
              thumbnail2x: thumbnail(size: 510) {
                url
              }
              lender {
                user {
                  firstName
                }
              }
            }
          }
        }
      }
    }
  }
`;
exports.ordersMessagesByUser = (0, graphql_tag_1.default) `
  ${order_1.orderMessagesFragment}
  query OrdersMessagesByUser($perPage: Int!, $after: String) {
    orders(first: $perPage, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          number
          statusDisplay
          reservations {
            rentalStartDate
            rentalEndDate
          }
          ...OrderMessagesFragment
          lines {
            productName
            variantName
            variant {
              id
              product {
                name
                id
                slug
              }
            }
            thumbnail {
              alt
              url
            }
            thumbnail2x: thumbnail(size: 510) {
              url
            }
            lender {
              user {
                firstName
                id
              }
            }
          }
        }
      }
    }
  }
`;
exports.orderDetailsByTokenQuery = (0, graphql_tag_1.default) `
  ${order_1.orderDetailFragment}
  query OrderByToken($token: UUID!) {
    orderByToken(token: $token) {
      ...OrderDetail
    }
  }
`;
exports.userOrderDetailsByTokenQuery = (0, graphql_tag_1.default) `
  ${order_1.orderDetailFragment}
  ${invoice_1.invoiceFragment}
  query UserOrderByToken($token: UUID!) {
    orderByToken(token: $token) {
      ...OrderDetail
      invoices {
        ...InvoiceFragment
      }
    }
  }
`;
exports.orderRatingByTokenQuery = (0, graphql_tag_1.default) `
  query orderRatingByToken($token: String!) {
    orderByJwtToken(token: $token) {
      status
      lines {
        id
        ratingByCustomer
        feedbackByCustomer
        productName
      }
    }
  }
`;
exports.messagesByUser = (0, graphql_tag_1.default) `
  query MessagesByUser($perPage: Int!, $after: String) {
    orderMessages(
      first: $perPage
      after: $after
      sortBy: { direction: DESC, field: SENT }
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          order {
            id
            number
            user {
              firstName
            }
            reservations {
              rentalStartDate
              rentalEndDate
            }
            lines {
              returnAddress {
                id
              }
              thumbnail {
                url
              }
              productName
              lender {
                user {
                  firstName
                }
              }
            }
          }
          author {
            id
            firstName
            avatar {
              url
            }
          }
          messageBody
          sent
          archived
          read
        }
      }
    }
  }
`;
//# sourceMappingURL=orders.js.map